import styles from './index.module.scss';
import commonStyles from './../common.module.scss';
import { DEPOT_TABLE_BY_CLIENT_COLUMNS, DEPOT_TABLE_BY_DEPOSIT_COLUMNS, DEPOT_TABLE_BY_DEPOT_COLUMNS, DEPOT_TABLE_BY_DOC_COLUMNS, DOCUMENT_STATUS_OPTIONS } from "./constants";
import { Table, Tabs, Tooltip } from "antd";
import { formatAmount } from "../../../../../utils";
import CustomTable from '../CustomTable';
import './../tabs.scss';
import './../popups.scss';
import { CircleIcon, InfoCircleFilledIcon, SettingsIcon } from '../../../../common/Icons';
import CardBody from '../CardBody';
import CardHeader from '../CardHeader';
import CardContainer from '../CardContainer';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { useRef, useState } from 'react';
import { useQuery } from 'react-query';
import { getCollaboratorDocsProcessingData } from '../../../../../api';
import { ConfirmPopup } from 'primereact/confirmpopup';
import Select from "react-select";
import ProcessingDeadlineCardSkeleton from './skeleton';

export default function ProcessingDeadlineCard({
  collaboratorId,
  selectedPeriod,
  year,
  typeData,
  isActive,
  clientsOptions,
  onAmountChange,
  onLoadingData
}) {
  const { token, navCommunity } = useSelector((state) => state.auth);
  const [filters, setFilters] = useState({
    excludedClients: [],
    docStatus: null
  });
  const [filtersToParams, setFiltersToParams] = useState({
    excludedClients: [],
    docStatus: null
  });
  const [processingDeadlineData, setProcessingDeadlineData] = useState([]);
  const [depositsData, setDepositsDate] = useState([]);
  const [processingDeadlineDataByClients, setProcessingDeadlineDataByClients] = useState([]);
  const [processingDeadlineTotals, setProcessingDeadlineTotals] = useState({
    respected: 0,
    notProcessedYet: 0
  });
  const [isAchieved, setIsAchieved] = useState(false);
  const [percentage, setPercentage] = useState(0);
  const processingDeadlineFiltersIconRef = useRef(null);
  const [showFiltersModal, setShowFiltersModal] = useState(false);

  const getCollaboratorDocsProcessingDataQuery = useQuery(
    [
      "getCollaboratorDocsProcessingData",
      token,
      navCommunity,
      collaboratorId,
      filtersToParams,
      year,
      selectedPeriod,
    ],
    async () => {
      if (token && navCommunity && collaboratorId) {
        try {
          onLoadingData('rdt', true);

          const response = await getCollaboratorDocsProcessingData({
            token,
            organizationId: navCommunity.id,
            collaboratorId,
            startDate: `${year}-${selectedPeriod.start}`,
            endDate: `${year}-${selectedPeriod.end}`,
            excludedClients: filtersToParams.excludedClients.map(it => it.value),
            docStatus: filtersToParams.docStatus?.value
          });

          const {
            result,
            resultByClient,
            globalStats: {processedInTime, notProcessedYet},
            deposits
          } = response.data.data;

          setProcessingDeadlineData(result);
          setDepositsDate(deposits);
          setProcessingDeadlineDataByClients(resultByClient)
          setProcessingDeadlineTotals({
            respected: processedInTime,
            notProcessedYet: notProcessedYet
          });

          const respectedClients = resultByClient.filter(item => item.nonRespectedDeposits === 0);
          const nonRespectedClients = resultByClient.filter(item => item.nonRespectedDeposits > 0);

          const isAchieved = respectedClients.length === resultByClient.length;
          const percentage = nonRespectedClients.length === 0 ? 100 : (respectedClients.length * 100) / resultByClient.length;

          setIsAchieved(isAchieved);
          setPercentage(percentage);
          if (isAchieved) {
            onAmountChange('rdt', typeData.amount);
          } else {
            onAmountChange('rdt', 0);
          }
        } catch (e) {
          console.error(e);
          return null;
        } finally {
          onLoadingData('rdt', false);
        }
      }
    }
  );

  const renderByDocumentTable = () => {
    return (
      <CustomTable
        columns={DEPOT_TABLE_BY_DEPOSIT_COLUMNS}
        dataSource={depositsData}
      />
    )
  };

  const renderByClientTable = () => {
    return (
      <CustomTable
        columns={DEPOT_TABLE_BY_CLIENT_COLUMNS}
        dataSource={processingDeadlineDataByClients}
        summary={(pageData) => {
          let totalDeposits = 0;
          let totalRespectedDeposits = 0;
          let totalNonRespectedDeposits = 0;

          processingDeadlineDataByClients.forEach((item) => {
            totalDeposits += item.totalDeposits;
            totalRespectedDeposits += item.respectedDeposits;
            totalNonRespectedDeposits += item.nonRespectedDeposits;
          });

          const percentageRespectedDeposits = totalDeposits === 0 ? 0 : totalRespectedDeposits * 100 / totalDeposits;
          const percentageNonRespectedDeposits = totalDeposits === 0 ? 0 : totalNonRespectedDeposits * 100 / totalDeposits;

          return (
            <>
              <Table.Summary.Row>
                <Table.Summary.Cell index={0} align="left" className="table-cell-bold">
                  Total
                </Table.Summary.Cell>
                <Table.Summary.Cell index={1} align="center" className="table-cell-bold">
                  --
                </Table.Summary.Cell>
                <Table.Summary.Cell index={2} align='center' className="table-cell-bold">
                  {totalDeposits}
                </Table.Summary.Cell>
                <Table.Summary.Cell index={3} align='center' className="table-cell-bold">
                  {totalRespectedDeposits}
                </Table.Summary.Cell>
                <Table.Summary.Cell index={4} align='center' className="table-cell-bold">
                  {totalNonRespectedDeposits}
                </Table.Summary.Cell>
                <Table.Summary.Cell index={5} align='center' className="table-cell-bold">
                  {percentageRespectedDeposits === 0 || percentageRespectedDeposits === 100 ? percentageRespectedDeposits : formatAmount(percentageRespectedDeposits, false)}%
                </Table.Summary.Cell>
                <Table.Summary.Cell index={6} align='center' className="table-cell-bold">
                  {percentageNonRespectedDeposits === 0 || percentageNonRespectedDeposits === 100 ? percentageNonRespectedDeposits : formatAmount(percentageNonRespectedDeposits, false)}%
                </Table.Summary.Cell>
              </Table.Summary.Row>
            </>
          );
        }}
      />
    );
  };

  if (getCollaboratorDocsProcessingDataQuery.isFetching) {
    return (
      <ProcessingDeadlineCardSkeleton />
    )
  }

  return (
    <CardContainer className={classNames({
      [styles.card]: true,
      [commonStyles.card_blured]: !isActive
    })}>
      <ConfirmPopup
        target={processingDeadlineFiltersIconRef.current}
        visible={showFiltersModal}
        acceptLabel="Appliquer"
        rejectLabel='Annuler'
        acceptClassName={commonStyles.filters_popup_accept_btn}
        rejectClassName={commonStyles.filters_popup_reject_btn}
        accept={() => {
          setFiltersToParams({...filters});
          setShowFiltersModal(false);
        }}
        reject={() => {
          setFilters({...filtersToParams});
          setShowFiltersModal(false);
        }}
        group="headless"
        className='bonus_custom_popup bonus_custom_popup_to_left'
        dismissable={false}
        style={{ width: '400px', left: '-50px' }}
        message={
        <div>
          <div style={{ width: '100%' }}>
            <label>
              <span className="popup_label">Clients à ignorés</span>
              <Select
                className="popup_select"
                isMulti={true}
                isSearchable={true}
                isClearable={true}
                isDisabled={false}
                maxMenuHeight={220}
                placeholder='Clients à ignorés'
                options={clientsOptions}
                value={filters.excludedClients}
                onChange={(inputValue) =>
                  setFilters({ ...filters, excludedClients: inputValue })
                }
                styles={{ width: '300px' }}
              />
            </label>
          </div>

          <div style={{ width: '100%' }}>
            <label>
              <span className="popup_label">Status de document</span>
              <Select
                className="popup_select"
                isSearchable={true}
                isClearable={true}
                isDisabled={false}
                maxMenuHeight={220}
                placeholder='Status de document'
                options={DOCUMENT_STATUS_OPTIONS}
                value={filters.docStatus}
                onChange={(inputValue) =>
                  setFilters({
                    ...filters,
                    docStatus: inputValue
                  })
                }
                styles={{ width: '300px' }}
              />
            </label>
          </div>
          </div>
        }
      />
      {!isActive && (
        <div className={commonStyles.blured_text}>
          Ce type de bonus n’est pas configuré pour la période choisie.
        </div>
      )}
      <CardHeader
        percentage={formatAmount(
          percentage,
          false
        )}
        amount={typeData.amount}
        title={typeData.label}
        isPositif={isAchieved}
        detailsBox={{
          value:
            processingDeadlineData.length === 0 ||
            (processingDeadlineTotals.respected * 100) /
              processingDeadlineData.length ===
              100
              ? 0
              : processingDeadlineTotals.notProcessedYet,
          label: "Nbr. de factures restantes",
          // isPositif: processingDeadlineTotals.notProcessedYet === 0,
          isPositif: isAchieved
        }}
      />
      <CardBody
        title={
          <div className={commonStyles.card_body_title}>
            <p>{typeData.description}</p>
            <Tooltip
              title="Traitement des documents dans un délai maximal de quatre semaines après leur date de
          dépôt"
            >
              <InfoCircleFilledIcon />
            </Tooltip>

            <div
              ref={processingDeadlineFiltersIconRef}
              className={commonStyles.card_filters}
              onClick={
                () =>
                  setShowFiltersModal(!showFiltersModal)
              }
            >
              {
                filtersToParams.excludedClients.length > 0 && (
                  <Tooltip
                    title={`Les clients exclus: ` + filtersToParams.excludedClients.map(it => it.label).join(', ')}
                  >
                    <CircleIcon
                      fill="red"
                      width="6px"
                      height="6px"
                      className={commonStyles.card_filters_indicator}
                    />
                  </Tooltip>
                )
              }
              <SettingsIcon fill="#000" />
            </div>
          </div>
        }
      >
        <div className={styles.container}>
          <div className={styles.content}>
            <Tabs
              size='small'
              className='bonus_custom_tabs'
              centered
              animated
              items={[
                {
                  key: '1',
                  label: 'Par document',
                  children: renderByDocumentTable(),
                },
                {
                  key: '2',
                  active: true,
                  label: 'Par client',
                  children: renderByClientTable(),
                },
              ]}
            />
          </div>
        </div>
      </CardBody>
    </CardContainer>
  );
}
